const Theme = {
    colors: {
        dark: "#000000",
        yellow: "#FFCB00",
        red: "#CC092F",
    }
}

export default Theme;